/** Default page size for admin list tables (matches API default). */
export const ADMIN_PAGE_SIZE = 25;
